"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { StaticImageData } from "next/image";
import { BRAND, NETWORK } from "@/lib/constant";
import { useTechNetwork } from "@/hooks/animations/useTechNetwork";
import TechNode from "./TechNode";
import TechStackChips from "./TechStackChips";
interface TechNetworkProps {
  name: string;
  image: string | StaticImageData;
  techStack: string[];
  slug: string;
}
const TechNetwork = t0 => {
  const $ = _c(43);
  const {
    name,
    image,
    techStack,
    slug
  } = t0;
  let t1;
  if ($[0] !== slug || $[1] !== techStack) {
    t1 = {
      techStack,
      seed: slug
    };
    $[0] = slug;
    $[1] = techStack;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    blueprints,
    edges,
    stageRef,
    nodeEls,
    lineEls,
    size
  } = useTechNetwork(t1);
  const dim = size || 1;
  let t2;
  if ($[3] !== name || $[4] !== techStack) {
    t2 = <div className="md:hidden"><TechStackChips name={name} techStack={techStack} /></div>;
    $[3] = name;
    $[4] = techStack;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div aria-hidden={true} className="pointer-events-none absolute inset-0" style={{
      background: `radial-gradient(60% 55% at 50% 50%, ${BRAND}12, transparent 72%)`
    }} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== name) {
    t4 = name.split(" ");
    $[7] = name;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4[0]) {
    t5 = <p className="pointer-events-none absolute left-6 top-5 z-30 text-lg font-bold uppercase tracking-[0.3em] text-white">{t4[0]}’s Stack</p>;
    $[9] = t4[0];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      maxWidth: NETWORK.maxSize
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `0 0 ${dim} ${dim}`;
  let t8;
  if ($[12] !== dim || $[13] !== edges || $[14] !== lineEls) {
    let t9;
    if ($[16] !== dim || $[17] !== lineEls) {
      t9 = (e, i) => <line key={`edge-${e.a}-${e.b}-${i}`} ref={el => {
        lineEls.current[i] = el;
      }} x1={dim / 2} y1={dim / 2} x2={dim / 2} y2={dim / 2} stroke="#727272" strokeWidth={1} strokeLinecap="round" opacity={0} />;
      $[16] = dim;
      $[17] = lineEls;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    t8 = edges.map(t9);
    $[12] = dim;
    $[13] = edges;
    $[14] = lineEls;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[19] !== dim || $[20] !== t7 || $[21] !== t8) {
    t9 = <svg width={dim} height={dim} viewBox={t7} className="pointer-events-none absolute inset-0 z-0 h-full w-full">{t8}</svg>;
    $[19] = dim;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      borderColor: BRAND,
      boxShadow: `0 6px 20px -8px ${BRAND}, 0 0 0 6px ${BRAND}12`
    };
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== image || $[25] !== name) {
    t11 = <div className="absolute left-1/2 top-1/2 z-60 -translate-x-1/2 -translate-y-1/2"><div className="relative h-14 w-14 overflow-hidden rounded-full border-2 bg-white md:h-16 md:w-16" style={t10}><Image src={image} alt={name} fill={true} sizes="64px" className="object-cover" /></div></div>;
    $[24] = image;
    $[25] = name;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== blueprints || $[28] !== nodeEls) {
    let t13;
    if ($[30] !== nodeEls) {
      t13 = (b, i_0) => <TechNode key={`${b.name || "dot"}-${i_0}`} ref={el_0 => {
        nodeEls.current[i_0] = el_0;
      }} name={b.name} label={b.label} important={b.important} accent={BRAND} />;
      $[30] = nodeEls;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    t12 = blueprints.map(t13);
    $[27] = blueprints;
    $[28] = nodeEls;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[32] !== stageRef || $[33] !== t11 || $[34] !== t12 || $[35] !== t9) {
    t13 = <div ref={stageRef} className="relative mx-auto aspect-square w-full" style={t6}>{t9}{t11}{t12}</div>;
    $[32] = stageRef;
    $[33] = t11;
    $[34] = t12;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t13 || $[38] !== t5) {
    t14 = <div className="relative isolate hidden overflow-hidden rounded-[2rem] border border-black/5 md:block bg-accent-foreground">{t3}{t5}{t13}</div>;
    $[37] = t13;
    $[38] = t5;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t14 || $[41] !== t2) {
    t15 = <>{t2}{t14}</>;
    $[40] = t14;
    $[41] = t2;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
export default TechNetwork;